@if(spinnerService.current(); as spinner) {
<common-spinner></common-spinner>
<div class="dashboard-spinner-text" (click)="backClick($event)">{{ spinner.text }}</div>
}